import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FileUtilService } from '../../../core/service/FileUtil/file-util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IBaseService } from '../../../core/service/ibase-service';
import { Row } from 'ng2-smart-table/lib/data-set/row';
import { AbstractBaseListComponent } from '../../../core/component/abstract-base-list-component';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { MatTableDataSource } from '@angular/material';
import { ColumnModel } from 'neo-table-lib';
import { getColumnExists, getColumnObject } from 'src/app/core/utils/helpers';
import { OrderingData } from '../../../core/modal/ordering-data';
import { AclDataModal } from '../../../shared/sidebar/acl-data-modal';
import { environment } from '../../../../environments/environment';
import { SearchData } from '../../../core/modal/search-data';
import { ResponseCode } from '../../../core/constant/response-code';
import { PaginationData } from '../../../core/modal/pagination-data';
import { TableKeyEnum } from 'src/app/core/enum/table-key.enum';
import { PartyTypeConstant } from '../../party/modal/party-type-constant';
import { PartyModuleParamConfigModel } from '../../party/modal/party-module-param-config-model';
import { vendorlist } from '../vendorList';
import { VendorModal } from '../modal/vendor-Modal';
import { VendorService } from '../service/vendor.service';

@Component({
  selector: 'app-vendor-registration',
  templateUrl: './vendor-registration.component.html',
  styleUrls: ['./vendor-registration.component.css']
})
export class VendorRegistrationComponent extends AbstractBaseListComponent<VendorModal> implements OnInit {
  private readonly MODULE_PARAM_CONFIG_KEY: string = 'party';

  @ViewChild('actionCol') actionCol: TemplateRef<any>;
  @ViewChild('statusWrapper') statusWrapperRef: TemplateRef<any>;
  public dataList: Array<VendorModal>;
  addUpdateUrl: string = 'module/vendor/vendor-add-update';
  partyTypeList = PartyTypeConstant;
  public moduleParam: PartyModuleParamConfigModel = new PartyModuleParamConfigModel(this.moduleParamConfigGlobService);
  PartyTitle = "Vendor Registration"
  dataSource = new MatTableDataSource([]);
  filteredData: any;
  allDataList: VendorModal[];
  priceBookNeoGridSettings: any = {};
  vendorlist = vendorlist;
  allColumns: any[] = [
    {
      colKey: 'index',
      default: 'Sr No.',
      rowKey: 'id',
      isNumber: true,
      width: '5%',
    },
    {
      colKey: 'companyName',
      default: this.moduleParamConfigGlobService.getLabel(
        this.MODULE_PARAM_CONFIG_KEY,
        'party_name',
        'Vendor Name'
      ),
      rowKey: 'companyName',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'partyTypeString',
      default: this.moduleParamConfigGlobService.getLabel(
        this.MODULE_PARAM_CONFIG_KEY,
        'partyType',
        'Vendor Type'
      ),
      rowKey: 'partyTypeString',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'gstNumber',
      default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'gst_number', 'GST Number'),
      rowKey: 'gstNumber',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'country',
      default: 'country',
      rowKey: 'country',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'state',
      default: 'state',
      rowKey: 'state',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'partyWebsite',
      default: 'company website',
      rowKey: 'partyWebsite',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'status',
      default: 'status',
      rowKey: 'status',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'actionCol',
      default: 'Action',
      rowKey: 'id',
      isNumber: false,
      isStickyEnd: true,
      width: '8%',
    },
  ];
  allFinalColumns: ColumnModel[] = [];
  tableKeyEnum = TableKeyEnum.PARTY;
  displayedColumns: string[];
  defaultSortCol = 'dateString';
  defaultSortDirection = 'asc';
  constructor(
    public service: VendorService,
    public fileUtil: FileUtilService,
    private router: Router,
    public toastrService: ToastrService,
    private moduleParamConfigGlobService: ModuleParamGlobConfigService
  ) {
    super(toastrService, router);
  }

  ngOnInit() {
    this.initAclParty();
    this.paginatioData = new PaginationData();
    this.authRole();
    if (!this.orderingData) {
      this.orderingData = new OrderingData();
      this.orderingData.column = 'id';
      this.orderingData.descending = false;
    }
    this.getListWithParams();
    this.setTableColumns();
  }

  getListWithParams() {
    let config = { page: this.paginatioData, order: this.orderingData, search: this.searchData };
    this.getMaterialRequestData(config);
  }

  getMaterialRequestData(config) {
    let params = this.getGridSettingInfo(config);
    this.service.getAllByPagination(params).subscribe((res) => {
      this.setList(res.dataList);
      this.totalRecords = res.totalRecords;
      this.priceBookNeoGridSettings.pageTotalLength = this.totalRecords;
    });
  }

  onFilterChange(filterObj) {
    let serverFilterObj: SearchData[] = this.service.getServerFilterObj();
    if (filterObj) {
      let searchData = new SearchData();
      searchData = filterObj;
      filterObj['filter'] = filterObj['filter'].trim();
      searchData.filterValue = filterObj['filter'];

      if (searchData.filterValue) {
        searchData.filterColumn = 'SearchBox';
        serverFilterObj = this.service.setServerFilterObj([searchData]);
      } else {
        serverFilterObj = new Array<SearchData>();
      }
    } else {
      serverFilterObj = new Array<SearchData>();
    }
    this.searchData = JSON.parse(JSON.stringify(serverFilterObj));
    this.getListWithParams();
  }

  initAclParty() {
    try {
      this.isDeleteAllow = !this.hideDeleteButton();
      let aclModule: Map<string, AclDataModal> = new Map<string, AclDataModal>();
      let aclDataString = localStorage.getItem(environment.ACL_LOCAL_KEY);
      if (aclDataString) {
        aclModule = new Map(JSON.parse(aclDataString));
        let serviceName: string = this.getService().getModuleName();
        let acl: AclDataModal = aclModule.get(serviceName);

        if (acl) {
          this.isAddAllow = acl.create == 1;
          this.isDeleteAllow = acl.delete == 1 && !this.hideDeleteButton();
          this.isEditAllow = acl.update == 1;
          this.isViewAllow = acl.view == 1;
        }
      }
    } catch (e) {
      console.error('Error in initAcl', e);
    }
  }

  setTableColumns() {
    // Input Table Columns
    this.allColumns.map((column, columnIndex) => {
      column.enableSort = true;
      // column.isFilterAllow = true;
      column.enableEdit = this.isEditAllow;
      column.enableDelete = this.isDeleteAllow;
      let pushcol = false;
      column.isFilterAllow = false;
      column.enableSort = false;
      if (column.colKey == 'actionCol') {
        pushcol = true;
        column.enableEdit = false;
        column.enableDelete = false;
        column.customControls = [this.actionCol];
        column.isExpandable = false;
      } else {
        pushcol = true;
      }

      const pushcolVal = getColumnObject(column);
      if (pushcol && !getColumnExists(this.allFinalColumns, column.colKey)) {
        this.allFinalColumns.splice(columnIndex, 0, pushcolVal);
      }
    });

    this.priceBookNeoGridSettings = {
      showAdvanceSearch: true,
      showFooter: true,
      showPagination: true,
      showFilter: true,
      tableId: this.tableKeyEnum,
      perPage: 10,
      pageSizeOptions: [5, 10, 15, 20, 50, 100],
      serverSideSortPagination: false,
      serverSideFilter: false,
      pageTotalLength: 0,
      sort: false,
      defaultSortCol: '',
      defaultSortDirection: 'asc',
      columns: this.allColumns,
    };

    this.displayedColumns = this.allFinalColumns.map((column) => column.colKey);
    if (this.priceBookNeoGridSettings.serverSideSortPagination && this.priceBookNeoGridSettings.perPage) {
      this.setPaginationPerPage(this.priceBookNeoGridSettings.perPage);
    }
  }

  setDataSource(data) {
    this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    this.dataSource.connect().subscribe((data) => {
      this.filteredData = data;
    });
    if (this.service.pagination) setTimeout(() => this.assignValue(), 0);
  }

  assignValue() {
    this.dataSource.paginator.pageIndex = this.service.pagination.pageIndex;
    this.dataSource.paginator.pageSize = this.service.pagination.perPage;
  }

  getService(): IBaseService<VendorModal> {
    return this.service;
  }

  ngAfterViewInit() {
    this.allColumns.forEach((col) => {
      if (col.colKey == 'status') {
        col.customControls = [this.statusWrapperRef];
      }
    });
  }

  setList(list: Array<VendorModal>) {
    //this.dataList = ;

    this.valuePrepareFunction(this.vendorlist);
    this.setDataSource(this.vendorlist);
  }

  public getTableColumn(): any {
    let columnList = {
      companyName: {
        title: this.moduleParamConfigGlobService.getLabel(
          this.MODULE_PARAM_CONFIG_KEY,
          'party_name',
          'Business Partner Name'
        ),
        filter: false,
      },
      partyTypeString: {
        title: this.moduleParamConfigGlobService.getLabel(
          this.MODULE_PARAM_CONFIG_KEY,
          'partyType',
          'Business Partner Type'
        ),
        filter: false,
      },
      gstNumber: {
        title: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'gst_number', 'GST Number'),
        filter: false,
      },
    };

    return columnList;
  }

  public onDeleteClick(data: VendorModal) {
    if (confirm('Are you sure want to delete this record.')) {
      //this.delete(data);
      this.getService()
        .delete(data)
        .subscribe((response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          this.toastrService.success('Data has been deleted successfully.', 'Success');
          this.getListWithParams();
        });
    }
  }

  public onEditClick(modal: VendorModal) {
    this.router.navigate([this.addUpdateUrl, modal.id]);
  }

  onSmartTableEditClick(eventData: Row) {
    this.onEditClick(eventData.getData());
  }

  onSmartTableDeleteClick(eventData: Row) {
    this.onDeleteClick(eventData.getData());
  }

  onNeoTableEditClick(event) {
    let index = event.rowIndex;
    this.onEditClick(this.filteredData[index]);
  }

  onNeoTableDeleteClick(event) {
    let index = event.rowIndex;
    this.onDeleteClick(this.filteredData[index]);
  }

  onHeaderRefresh(event: void) {
    //this.getList(this.paginatioData, this.orderingData);
    this.getListWithParams();
  }

  generatePdf() {
    this.service.getPartyPrintPdf();
  }

  generateCSV() {
    this.service.getPartyPrintExcel();
  }

  setToService() {
    // let Obj = {
    //   pageIndex: this.dataSource.paginator.pageIndex,
    //   perPage: (this.dataSource.paginator.pageSize = 10),
    // };
    // this.service.pagination = Obj;
  }

  private valuePrepareFunction(list) {
    this.setToService();
    list.forEach((list) => {
      if (list.id < 0) {
        this.dataList.pop();
      }
      list.partyTypeString = list.partyType ? list.partyType.label : '';
    });
  }

  pageChange(event) {
    this.paginatioData = new PaginationData();
    this.paginatioData.pageNumber = event.pageIndex + 1;
    this.paginatioData.rowsPerPage = event.pageSize;
    this.getListWithParams();
  }
}
